module.exports = __webpack_public_path__ + "static/img/Hotline.3b2b0df4.png";